"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoggedInUser = exports.getOutletName = exports.getSubBusinessName = exports.getBusinessDetails = exports.AuthGuard = exports.getUserType = exports.getUserNameFromToken = exports.isLoggedIn = exports.isTokenExpired = void 0;
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const userService_1 = require("../../modules/user/service/userService");
const Env_1 = require("../../utils/tsUtils/Env");
const moment = require('moment');
const isTokenExpired = (token) => {
    const decodedJwt = (0, jwt_decode_1.default)(token);
    if (decodedJwt === null) {
        return true;
    }
    const value = moment().unix();
    return decodedJwt.exp <= value;
};
exports.isTokenExpired = isTokenExpired;
const isLoggedIn = () => __awaiter(void 0, void 0, void 0, function* () {
    const userService = new userService_1.UserService(Env_1.APIPATHENV);
    try {
        let token = localStorage.getItem('access_token');
        if (token == null) {
            return false;
        }
        else {
            let result = (0, exports.isTokenExpired)(token);
            if (result) {
                let userType = localStorage.getItem('usertype');
                if (userType == 'HAdmin') {
                    try {
                        let refreshToken = localStorage.getItem('refresh_token');
                        if (refreshToken) {
                            let res = yield userService.getUserTokenWithRefreshToken(refreshToken);
                            localStorage.setItem('access_token', res.accessToken);
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                    catch (err) {
                        localStorage.clear();
                        return false;
                    }
                }
                else {
                    try {
                        let refreshToken = localStorage.getItem('refresh_token');
                        if (refreshToken) {
                            let res = yield userService.getTokenWithRefreshToken(refreshToken);
                            localStorage.setItem('access_token', res.accessToken);
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                    catch (err) {
                        localStorage.clear();
                        return false;
                    }
                }
            }
            return true;
        }
    }
    catch (err) {
        throw new Error('User is not logged in');
    }
});
exports.isLoggedIn = isLoggedIn;
const getUserNameFromToken = () => {
    const token = localStorage.getItem('access_token');
    if (token == null) {
        return '';
    }
    const decodedJwt = (0, jwt_decode_1.default)(token);
    if (decodedJwt === null)
        return '';
    return decodedJwt.username;
};
exports.getUserNameFromToken = getUserNameFromToken;
const getUserType = () => localStorage.getItem('usertype');
exports.getUserType = getUserType;
function AuthGuard({ children }) {
    // const auth = useSelector((state: RootState) => state.authReducer);
    // console.log("Auth", auth)
    // const history = useNavigate();
    // if (auth !== undefined) {
    //     history("/auth/sign-in");
    //     return;
    //     // return <Navigate to="/auth/sign-in" />
    // }
    // else
    return children;
}
exports.AuthGuard = AuthGuard;
const getBusinessDetails = () => {
    let businessData = localStorage.getItem('business_data');
    if (businessData) {
        return JSON.parse(businessData);
    }
    return null;
};
exports.getBusinessDetails = getBusinessDetails;
const getSubBusinessName = () => localStorage.getItem('sub_business_name');
exports.getSubBusinessName = getSubBusinessName;
const getOutletName = () => localStorage.getItem('outlet_name');
exports.getOutletName = getOutletName;
const getLoggedInUser = () => localStorage.getItem('usertype');
exports.getLoggedInUser = getLoggedInUser;
